module.exports = __webpack_public_path__ + "static/media/zona-norte.d5855a37.jpg";